<!-- @deprecated This component is deprecated and should not be used -->
<template>
  <div class="flex flex-col">
    <div class="flex flex-col">
      <VcPriceDisplay
        v-if="shouldUseActualPrice(value?.list, value?.actual)"
        class="font-black"
        :class="priceColorClass"
        :value="value?.actual"
      />

      <VcPriceDisplay v-else class="font-bold text-[--price-color]" :value="value?.list" />

      <span class="hidden sm:inline md:hidden xl:inline print:!block">
        {{ $t("ui_kit.suffixes.per_item") }}
      </span>
    </div>

    <div class="leading-4">
      <VcPriceDisplay
        v-if="shouldUseActualPrice(value?.list, value?.actual)"
        class="text-xs font-bold text-neutral-400 line-through"
        :value="value?.list"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { shouldUseActualPrice } from "@/ui-kit/utilities/price";
import type { MoneyType, PriceType } from "@/core/api/graphql/types";

interface IProps {
  value?: PriceType | { list: MoneyType; actual: MoneyType };
  priceColorClass?: string;
}

withDefaults(defineProps<IProps>(), {
  priceColorClass: "text-[--color-primary]",
});

// eslint-disable-next-line no-console
console.warn("[UIKit][warn] VcItemPrice is deprecated and should not be used.");
</script>
